import { Fragment, type ReactNode } from 'react'

/**
 * Renders a lightweight `**bold**` marker inline, so authors can emphasize part of a
 * help text line (e.g. `**Do not** exceed 80 lbs.`) without a full markdown parser.
 * Plain text with no markers renders unchanged.
 */
export function renderInlineMarkup(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g).filter((part) => part !== '')

  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>
    }
    return <Fragment key={i}>{part}</Fragment>
  })
}
